import { CloseCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import iksBg from "../../assets/chro-bg.png";
import { connect } from 'react-redux';

function CompanyValues({ isIksOpen, setIksOpen, chroAssets, isGamePaused }) {
    const [iframeSrc, setIframeSrc] = useState('');
    const [iframeTitle, setIframeTitle] = useState('Content');
    const [iframeAllow, setIframeAllow] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        console.log("chroAssets updated:", chroAssets);
        if (!chroAssets || !chroAssets.orgValueAsset) return;
        const url = chroAssets.orgValueAsset;

        if (url.endsWith('.pdf')) {
            // PDF content
            // setIframeSrc(`https://docs.google.com/viewer?url=${url}&embedded=true`);
            setIframeSrc(url);
            setIframeTitle('PDF Document');
            setIframeAllow('');
            setLoading(false);
        } else if (url.includes('youtube.com') || url.includes('youtu.be')) {
            // YouTube video
            const videoId = url.includes('youtube.com')
                ? new URL(url).searchParams.get('v')
                : url.split('/').pop();
            setIframeSrc(`https://www.youtube.com/embed/${videoId}`);
            setIframeTitle('YouTube Video');
            setIframeAllow('accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
            setLoading(false);
        } else if (url.match(/\.(jpeg|jpg|gif|png)$/) != null) {
            // Image content
            setIframeSrc(url);
            setIframeTitle('Image');
            setIframeAllow('');
            setLoading(false);
        } else {
            // Other content
            setIframeSrc(url);
            setIframeTitle('Content');
            setIframeAllow('');
            setLoading(false);
        }
    }, [chroAssets]);

    useEffect(() => {
        console.log("Modal open state changed:", isIksOpen);
    }, [isIksOpen]);

    return (
        <div>
            <Modal
                open={isIksOpen}
                onCancel={() => setIksOpen(false)}
                footer={null}
                closeIcon={false}
                className='r-c-c token-model'
                maskClosable={false}
                style={{ overflow: 'hidden !important', top: "0px" }}
                bodyStyle={{ height: "100vh", width: "90vw", overflow: 'hidden !important' }}
            >
                <div className='r-c-c-c need-parent-div'>
                    <div className='need-div-1'>{chroAssets?.orgFieldName}</div>
                    <div className='need-div-2' onClick={() => setIksOpen(false)}><CloseCircleOutlined /></div>
                    <div className='need-div-3'>
                        <img src={iksBg} className='full-img' alt="Background" />
                        {loading ? <div className="loading-text" style={{ position: "absolute", top: "46%", left: "46%", color: "", fontWeight: "bold" }}>Loading...</div> : <>
                            <iframe
                                className='r-c-c'
                                title={iframeTitle}
                                src={iframeSrc}
                                style={{
                                    position: 'absolute',
                                    top: iframeTitle === "Image" ? "12%" : '22%',
                                    left: iframeTitle === "Image" ? "11%" : '19%',
                                    width: iframeTitle === "Image" ? "100%" : '60%',
                                    height: iframeTitle === "Image" ? "80%" : '55%',
                                    border: 'none',
                                    padding: "10px",
                                    overflow: "auto"
                                }}
                                allow={iframeAllow}
                                allowFullScreen

                            >

                            </iframe>
                        </>}
                    </div>
                </div>
            </Modal>
        </div>
    );
}

const mapStateToProps = state => {
    const { step, chroAssets, isGamePaused } = state?.SeTu;
    return { step, chroAssets, isGamePaused };
};

const mapDispatchToProps = dispatch => ({
    // Define any dispatch actions if needed
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyValues);
